export const filterObjectKeys = (predicate, object) =>
  Object.keys(object).reduce((acc, key) => (predicate(key) ? { ...acc, [key]: object[key] } : acc), {})

export const filterObjectValues = (predicate, object) =>
  Object.keys(object).reduce((acc, key) => (predicate(object[key]) ? { ...acc, [key]: object[key] } : acc), {})

export const removeEmptyKeys = (obj) => {
  return Object.fromEntries(
    Object.entries(obj)
      .filter(([_, v]) => v != null)
      .map(([k, v]) => [k, v === Object(v) ? removeEmptyKeys(v) : v])
  )
}
